import { SubjectType } from './subject';

export enum CapabilityType {
  AccessBackOffice = 'access_back_office',
  AccessResellerBackOffice = 'access_reseller_back_office',
  ChangeAccountCompany = 'change_account_company',
  ChangeAccountReseller = 'change_account_reseller',
  DeactivateAccount = 'deactivate_account',
  DeleteAccountData = 'delete_account_data',
  ImpersonateAllUsers = 'impersonate_all_users',
  ImpersonateAllUsersWithNotification = 'impersonate_all_users_with_notification',
  ImpersonateOnlyTrialUsersWithNotification = 'impersonate_only_trial_users_with_notification',
  ManageAccountPreferences = 'manage_account_preferences',
  ManageAccountWallet = 'manage_account_wallet',
  ManageMultiFactorEnforcement = 'manage_multi_factor_enforcement',
  ManagePaymentDetails = 'manage_payment_details',
  ManagePermissions = 'manage_permissions',
  ManageTeamleaderOffice = 'manage_teamleader_office',
  ManageTeams = 'manage_teams',
  ManuallyManageAccountSubscription = 'manually_manage_account_subscription',
  RenumberDocuments = 'renumber_documents',
  SendTeamviewerRequest = 'send_teamviewer_request',
  StartSandboxSubscription = 'start_sandbox_subscription',
  SuspendAccounts = 'suspend_accounts',
}

export const enum CapabilityAccess {
  Granted = 'granted',
  Denied = 'denied',
}

export interface Capability {
  name: CapabilityType;
  access: CapabilityAccess;
}

export interface CapabilityEvaluationRequest {
  name: CapabilityType;
}

export interface CapabilityEvaluation {
  access: CapabilityAccess;
  name: CapabilityType;
  subject: SubjectType;
}
